import Axios from 'axios'
import { getPathName, getApiHash, getApiToken } from './helper';

const obtenerAnios = async (marca, modelo, rubro = "auto") => {
    const params = {
        hash: await getApiHash(),
        marca: marca?.label,
        modelo: modelo?.label,
        anio: 0,
        rubro
    }
    const headers = { 
        'content-type': 'application/json',
        "Authorization" : 'Bearer ' + await getApiToken()
    }
    return await Axios.post(await getPathName() + "/getaniosjson", params,
        {
            headers: headers
        }).then(function (response) {
            return response.data.anios;
        }).catch(function (error) {
            return error;
    });
};

export default obtenerAnios;